import { render, staticRenderFns } from "./TableColumnDebrisType.vue?vue&type=template&id=bc1c6088&scoped=true&"
import script from "./TableColumnDebrisType.vue?vue&type=script&lang=js&"
export * from "./TableColumnDebrisType.vue?vue&type=script&lang=js&"
import style0 from "./TableColumnDebrisType.vue?vue&type=style&index=0&id=bc1c6088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1c6088",
  null
  
)

export default component.exports